/* eslint max-len: ["error", 200] */

const React = require('react');
const { Route } = require('react-router');

const { DiscoveryRoutes } = require('@reverbdotcom/discovery-ui');

/*
 * All routes for the ReverbRouter are defined here. These are exported
 * separately so they can be shared between the client and server side
 * Router.
 *
 * Note: All routes here are defined with a relative route to support international
 * prefix routing, which is defined below in the actual export
 *
 * Please add a key to allow React to do some fancy DOM diffing (and to prevent an error in console)
 */
const Routes = [
  // DEPRECATED! PLEASE ADD ALL NEW ROUTES TO frontend/discovery-ui
  <Route
    key="software(/:categorySlug)"
    path="software(/:categorySlug)"
    getComponent={(_location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('components/digital_listings/index_page'));
      }, 'software');
    }}
  />,
  <Route
    key="software/:categorySlug/:brandSlug/:digitalListingId"
    path="software/:categorySlug/:brandSlug/:digitalListingId"
    getComponent={(_location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('components/digital_listings/show_page'));
      }, 'software');
    }}
  />,
  <Route
    key="my/selling/orders"
    path="my/selling/orders"
    getComponent={(_location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('components/dashboard/selling/orders/selling_orders_manager'));
      }, 'dashboard');
    }}
  />,
  <Route
    key="my/buying/orders"
    path="my/buying/orders"
    getComponent={(_location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('components/dashboard/buying/orders/buying_orders_manager'));
      }, 'dashboard');
    }}
  />,
  <Route
    key="my/selling/listings"
    path="my/selling/listings"
    getComponent={(_location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('components/dashboard/selling/listings_manager/listings_manager'));
      }, 'dashboard');
    }}
  />,
  <Route
    key="my/account"
    path="my/account"
    getComponent={(_location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('components/dashboard/shop_stats'));
      }, 'dashboard');
    }}
  />,
  <Route
    key="my/selling/reports/price_drop_listings"
    path="my/selling/reports/price_drop_listings"
    getComponent={(_location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('components/dashboard/selling/reports/price_drop_listings'));
      }, 'dashboard');
    }}
  />,
];

Routes.push(DiscoveryRoutes);

module.exports = Routes;



// WEBPACK FOOTER //
// ./javascripts/components/shared/routes.jsx